import { useEffect, useState, ChangeEvent } from 'react'
import { Col, Form, FormControl, FormSelect, Row } from 'react-bootstrap'
import { ExclamationCircleFill, FlagFill, InfoCircleFill } from 'react-bootstrap-icons'
import { isValidVatDE } from '../helpers/stammdaten.helper'
import { t } from '../locale'
import { getEuVatIdCountryCode, getRegisterEntry } from '../service/stammdaten'
import { ChangeEvt, CompanyForm } from '../types/stammdaten.type'
import { useOutsideClick } from '../hooks/useOutsideClick'
import KDayPicker from '../components/KDayPicker'

type UnthernamenProps = {
  form: CompanyForm
  handleChangeLocal: (e: ChangeEvt) => void
  handleDateInputChange: (e: ChangeEvent<HTMLInputElement>) => void
  history: (path: string, label: string, options?: { value: any; label: string }[]) => void
  options: any
  handleDateChange: (id: string, date: Date | null) => void
  required: any
}
export default function StammdatenUnthernamen({
  form,
  handleChangeLocal,
  handleDateInputChange,
  history,
  options,
  handleDateChange,
  required,
}: UnthernamenProps) {
  const [euVatIdCountryCode, setEuVatIdCountryCode] = useState<any[]>([])
  const [registerEntry, setRegisterEntry] = useState<any[]>([])
  const [datePickerFoundingDate, setDatePickerFoundingDate] = useState(false)

  useEffect(() => {
    fetchEuVatIdCountryCode()
    fetchRegisterEntry()
  }, [])

  useOutsideClick(() => {
    setDatePickerFoundingDate(false)
  }, 'date-picker-popup')

  const fetchEuVatIdCountryCode = async () => {
    try {
      const options = await getEuVatIdCountryCode()
      setEuVatIdCountryCode(options)
    } catch (err) {
      console.error('Fetch error EuVatIdCountryCode: ', err)
    }
  }

  const fetchRegisterEntry = async () => {
    try {
      const options = await getRegisterEntry()
      setRegisterEntry(options)
    } catch (err) {
      console.error('Fetch error register entry: ', err)
    }
  }

  return (
    <>
      <div id='company-data' className='mb-4'>
        {/* Unternehmensgegenstand */}
        <Row className='mt-4'>
          <Col className='col-sm-3'>
            <label className={`form-control-label ${required.corporate_purpose ? 'required' : ''}`}>
              {t('unternehmensgegenstand')}
            </label>
          </Col>
          <Col>
            <FormControl
              name={t('unternehmensgegenstand')}
              className='w-25 d-inline'
              type='text'
              id='corporate_purpose'
              value={form.corporate_purpose}
              required={required.corporate_purpose}
              onChange={handleChangeLocal}
            />
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() => history('stammdaten.corporate_purpose', t('unternehmensgegenstand'))}
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* Ort des Firmensitzes */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.location_of_headquarters ? 'required' : ''}`}
            >
              {t('ortFirmensitezes')}
            </label>
          </Col>
          <Col>
            <FormControl
              name={t('ortFirmensitezes')}
              className='w-25 d-inline'
              type='text'
              id='location_of_headquarters'
              value={form.location_of_headquarters}
              required={required.location_of_headquarters}
              onChange={handleChangeLocal}
            />
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() => history('stammdaten.location_of_headquarters', t('ortFirmensitezes'))}
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* country of headquarters */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.country_of_headquarters ? 'required' : ''}`}
            >
              {t('landFirmensitzes')}
            </label>
          </Col>
          <Col>
            <FormSelect
              name={t('landFirmensitzes')}
              className='w-25 d-inline'
              id='country_of_headquarters'
              value={form.country_of_headquarters}
              required={required.country_of_headquarters}
              onChange={handleChangeLocal}
            >
              <option value=''>--</option>
              {options.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {t(option.label)}
                </option>
              ))}
            </FormSelect>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history('stammdaten.country_of_headquarters', t('landFirmensitzes'), options)
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* Gründungsdatum */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label className={`form-control-label ${required.founding_date ? 'required' : ''}`}>
              {t('gründungsdatum')}
            </label>
          </Col>
          <Col>
            <Form.Control
              id='founding_date'
              name={t('gründungsdatum')}
              type='text'
              className='w-25 d-inline'
              value={form.founding_date || ''}
              onClick={() => setDatePickerFoundingDate(!datePickerFoundingDate)}
              onChange={handleDateInputChange}
              placeholder='DD.MM.YYYY'
              inputMode='numeric'
              maxLength={10}
              required={required.founding_date}
            />
            {form.founding_date && (
              <button
                type='button'
                className='btn btn-link btn-sm p-0 ms-1 text-danger'
                onClick={() => handleDateChange('founding_date', null)}
                title={t('Löschen') || 'Clear'}
              >
                <i className='fa fa-times' aria-hidden='true'></i>
              </button>
            )}
            <KDayPicker
              open={datePickerFoundingDate}
              value={form.founding_date}
              onSelect={d => {
                handleDateChange('founding_date', d)
                setDatePickerFoundingDate(false)
              }}
            />
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() => history('stammdaten.founding_date', t('gründungsdatum'))}
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        <hr />
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <FlagFill /> <label className='form-control-label'>{t('nationalesRecht')}</label>
          </Col>
        </Row>
        {/* Nationales Recht */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label className={`form-control-label ${required.nationality ? 'required' : ''}`}>
              {t('nationalesRecht')}
            </label>
          </Col>
          <Col>
            <FormSelect
              name={t('nationalesRecht')}
              className='w-25 d-inline'
              id='nationality'
              value={form.nationality}
              required={required.nationality}
              onChange={handleChangeLocal}
            >
              <option value=''>--</option>
              <option key='DE' value='DE'>
                {t('Deutschland')}
              </option>
              <option key='AT' value='AT'>
                {t('Österreich')}
              </option>
            </FormSelect>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history('stammdaten.nationality', t('nationalesRecht'), [
                  { value: 'DE', label: t('Deutschland') },
                  { value: 'AT', label: t('Österreich') },
                ])
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* USt-IdNr. */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.national_law.eu_vat_id_country_code ? 'required' : ''}`}
            >
              {t('ustNr')}
            </label>
          </Col>
          <Col className='col-sm-2 d-flex align-items-center'>
            <FormSelect
              name={t('ustNr')}
              className='d-inline'
              id='national_law.eu_vat_id_country_code'
              value={form.national_law.eu_vat_id_country_code}
              required={required.national_law.eu_vat_id_country_code}
              onChange={handleChangeLocal}
            >
              <option></option>
              {euVatIdCountryCode.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </FormSelect>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history(
                  'stammdaten.national_law.eu_vat_id_country_code',
                  t('ustNr'),
                  euVatIdCountryCode
                )
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
          <Col className='col-sm-2 d-flex align-items-center'>
            <FormControl
              name={t('eu_vat_id_number')}
              className='d-inline'
              type='text'
              id='national_law.eu_vat_id_number'
              value={form.national_law.eu_vat_id_number}
              onChange={handleChangeLocal}
              disabled={
                !form.national_law.eu_vat_id_country_code ||
                form.national_law.eu_vat_id_country_code === '--'
              }
              style={
                !form.national_law.eu_vat_id_country_code ||
                form.national_law.eu_vat_id_country_code === '--'
                  ? {
                      backgroundColor: '#e9ecef',
                      opacity: 0.65,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            />
            {form.national_law.eu_vat_id_country_code === 'DE' &&
              !!form.national_law.eu_vat_id_number &&
              !isValidVatDE(form.national_law.eu_vat_id_number) && (
                <ExclamationCircleFill
                  className='text-danger ms-1'
                  title='Ungültiges Format der USt-IdNr.'
                />
              )}
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history('stammdaten.national_law.eu_vat_id_number', t('eu_vat_id_number'))
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        <hr />
        <InfoCircleFill />{' '}
        <label className='form-control-label'>{t('registergerichtsinformationen')}</label>
        {/* Registereintrag */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.registry_court.register_entry ? 'required' : ''}`}
            >
              {t('registereintrag')}
            </label>
          </Col>
          <Col>
            <FormSelect
              name={t('registereintrag')}
              className='w-25 d-inline'
              id='registry_court.register_entry'
              value={form.registry_court.register_entry}
              required={required.registry_court.register_entry}
              onChange={handleChangeLocal}
              disabled={!form.nationality || form.nationality === '--'}
              style={
                !form.nationality || form.nationality === '--'
                  ? {
                      backgroundColor: '#e9ecef',
                      opacity: 0.65,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            >
              <option value=''>--</option>
              {registerEntry.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </FormSelect>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history(
                  'stammdaten.registry_court.register_entry',
                  t('registereintrag'),
                  registerEntry
                )
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* Registergericht  */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.registry_court.commercial_register ? 'required' : ''}`}
            >
              {t('registergericht')}
            </label>
          </Col>
          <Col>
            <FormControl
              name={t('registergericht')}
              className='w-25 d-inline'
              type='text'
              id='registry_court.commercial_register'
              value={form.registry_court.commercial_register}
              required={required.registry_court.commercial_register}
              onChange={handleChangeLocal}
              disabled={!form.nationality || form.nationality === '--'}
              style={
                !form.nationality || form.nationality === '--'
                  ? {
                      backgroundColor: '#e9ecef',
                      opacity: 0.65,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            ></FormControl>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history('stammdaten.registry_court.commercial_register', t('registergericht'))
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* Register-Nr */}
        <Row className='mt-4'>
          <Col className='col-sm-2'>
            <label
              className={`form-control-label ${required.registry_court.register_number ? 'required' : ''}`}
            >
              {t('registerNr')}
            </label>
          </Col>
          <Col>
            <FormControl
              name={t('registerNr')}
              className='w-25 d-inline'
              type='text'
              id='registry_court.register_number'
              value={form.registry_court.register_number}
              required={required.registry_court.register_number}
              onChange={handleChangeLocal}
              disabled={!form.nationality || form.nationality === '--'}
              style={
                !form.nationality || form.nationality === '--'
                  ? {
                      backgroundColor: '#e9ecef',
                      opacity: 0.65,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            ></FormControl>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() => history('stammdaten.registry_court.register_number', t('registerNr'))}
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
        {/* Firmenname laut Registergericht */}
        <Row className='mt-4'>
          <Col className='col-sm-3    '>
            <label
              className={`form-control-label ${required.registry_court.commercial_register_company_name ? 'required' : ''}`}
            >
              {t('firmennameLautRegistergericht')}
            </label>
          </Col>
          <Col>
            <FormControl
              name={t('firmennameLautRegistergericht')}
              className='w-25 d-inline bg-info2'
              type='text'
              id='registry_court.commercial_register_company_name'
              value={form.registry_court.commercial_register_company_name}
              required={required.registry_court.commercial_register_company_name}
              onChange={handleChangeLocal}
              disabled={!form.nationality || form.nationality === '--'}
              style={
                !form.nationality || form.nationality === '--'
                  ? {
                      backgroundColor: '#e9ecef',
                      opacity: 0.65,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            ></FormControl>
            <button
              type='button'
              className='btn btn-link btn-sm'
              onClick={() =>
                history(
                  'stammdaten.registry_court.commercial_register_company_name',
                  t('firmennameLautRegistergericht')
                )
              }
            >
              <i className='fa fa-history text-dark' aria-hidden='true'></i>
            </button>
          </Col>
        </Row>
      </div>
    </>
  )
}
